"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputToUSD = void 0;
/**
 * @param {string} amount - The value to be formatted.
 * @returns {string} - The formatted digit, or original/empty string based on conditions.
 */
const inputToUSD = (amount) => {
    if (!amount)
        return amount;
    let toReturn = amount.trim().replace(/[^\d]/g, "");
    const negative = amount.includes("-");
    // adds a decimal two digits from the end
    // prettier-ignore
    switch (toReturn.length) {
        case 0:
            toReturn = '0.00';
            break;
        case 1:
            toReturn = `0.0${toReturn}`;
            break;
        case 2:
            toReturn = `0.${toReturn}`;
            break;
        default:
            toReturn = `${toReturn.slice(0, toReturn.length - 2)}.${toReturn.slice(toReturn.length - 2, toReturn.length)}`;
            // removes leading zeros if the number is not a decimal
            if (toReturn[0] === '0' && toReturn[1] !== '.') {
                toReturn = toReturn.slice(1, toReturn.length);
            }
            break;
    }
    const parts = toReturn.split(".");
    let whole = parts[0];
    const decimal = parts[1];
    // places a comma for every 3 digits from the right
    if (whole.length > 3) {
        whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    toReturn = `${negative ? "-" : ""}$${whole}.${decimal}`;
    return toReturn;
};
exports.inputToUSD = inputToUSD;
